"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "rombiolo": {
    "4820f544": [{
      "hkey": "c7389e63",
      "slug": "rombiolo",
      "name": "Rombiolo",
      "primary": true,
      "skipSearch": false
    }],
    "moladi-garavati": [{
      "hkey": "c7389e63",
      "slug": "rombiolo",
      "name": "Rombiolo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "733b1fc0": [{
      "hkey": "c7389e63",
      "slug": "rombiolo",
      "name": "Rombiolo",
      "primary": true,
      "skipSearch": false
    }],
    "orsigliadi": [{
      "hkey": "c7389e63",
      "slug": "rombiolo",
      "name": "Rombiolo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "40cca2e5": [{
      "hkey": "ed394474",
      "slug": "pernocari-presinaci",
      "name": "Pernocari-Presinaci",
      "primary": true,
      "skipSearch": false
    }],
    "pernocari": [{
      "hkey": "ed394474",
      "slug": "pernocari-presinaci",
      "name": "Pernocari-Presinaci",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "a8baee59": [{
      "hkey": "ed394474",
      "slug": "pernocari-presinaci",
      "name": "Pernocari-Presinaci",
      "primary": true,
      "skipSearch": false
    }],
    "presinaci": [{
      "hkey": "ed394474",
      "slug": "pernocari-presinaci",
      "name": "Pernocari-Presinaci",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "rombiolo"
    }]
  }
};
exports["default"] = _default;